import React from 'react';
import ImageGrid from '../grid-layout/ImageGrid';
import { GallerySlide } from '../activity-details-section/activity-details-card/activity-details-card';
import { Button } from '@mui/material';
import { encodedTitle } from 'app/utils/common-utils/common-utils';
import { useNavigate } from 'react-router-dom';
import { Blog, BlogGalleryItem } from 'app/shared/reducers/blogs';

interface BlogListSingleProps {
  data: Blog;
  isFirst?: boolean;
  onLightboxOpen: (slides: GallerySlide[], index: number) => void;
}

const BlogListSingle = ({ data, isFirst = false, onLightboxOpen }: BlogListSingleProps) => {
  const navigate = useNavigate();

  const blogSlides: GallerySlide[] = (data?.eventGallery ?? []).map((img: BlogGalleryItem) => {
    if (img.type === 'videos') {
      return { type: 'video', src: img?.link, thumbnail: img?.thumbnail, title: '', sources: [{ src: img?.link, type: 'video/mp4' }] };
    }
    return { type: 'image', src: img?.link, thumbnail: img?.link, title: '' };
  });

  return (
    <div style={{ height: '430px', position: 'relative', borderRadius: '15px', overflow: 'hidden' }}>
      {data?.eventGallery?.length > 0 && (
        <ImageGrid onImageClick={(index: number) => onLightboxOpen(blogSlides, index)}>
          {data.eventGallery.map((item: BlogGalleryItem, index: number) => (
            <div key={index} className={`img_container ${item.type === 'videos' ? 'video-grid' : ''}`}>
              <img
                alt={data?.blogTitle || 'blog image'}
                src={item.type === 'videos' ? item?.thumbnail : item?.link}
                style={{ objectPosition: '1px 1%', objectFit: 'cover' }}
                loading={isFirst && index === 0 ? 'eager' : 'lazy'}
                width="800"
                height="430"
                decoding={isFirst && index === 0 ? 'sync' : 'async'}
                {...(isFirst && index === 0 ? ({ fetchpriority: 'high' } as any) : {})}
              />
            </div>
          ))}
        </ImageGrid>
      )}

      {data?.featured && (
        <div style={{
          position: 'absolute', top: '0', left: '0',
          background: '#674BFF', color: '#FFFF',
          padding: '5px 10px', borderRadius: '0 0 15px 0',
          zIndex: '999', fontSize: '12px',
        }}>
          <span style={{ fontWeight: 'bold' }}>Featured</span>
        </div>
      )}

      <Button
        variant="contained"
        size="small"
        style={{ position: 'absolute', bottom: 10, left: 10, background: '#F6F7F8', color: '#900095', textTransform: 'capitalize', borderRadius: '16px' }}
        onClick={() => navigate(`/blog-single/${encodedTitle(data?.blogTitle)}-${data?.id}`)}
      >
        {typeof data?.blogType === 'object' ? data.blogType.category : data?.blogType}
      </Button>
    </div>
  );
};

export default BlogListSingle;
